import { CoreIcon } from '../core-icon';
import logoAutopassSVG from '../../assets/logos/logo-autopass.svg';
import type { IconProps } from '../core-icon';

export const LogoAutopassIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={logoAutopassSVG} {...props} />;
};
